import { HistoryController as controller } from './history.controller';
import template from './history.html';

export const historyComponent = {
  name: 'historyComponent',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  controller,
  bindings: {
    events: '<',
    action: '&'
  }
};
